'use client';

import * as React from 'react';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from '@/components/ui/drawer';
import { cn } from '@/lib/utils';
import { useMediaQuery } from 'usehooks-ts';
interface BaseProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
}
interface RootCredenzaProps extends BaseProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  modal?: boolean;
}
const desktop = '(min-width: 768px)';
const Credenza = ({
  children,
  ...props
}: RootCredenzaProps) => {
  const isDesktop = useMediaQuery(desktop);
  const Credenza = isDesktop ? Dialog : Drawer;
  return <Credenza {...props} data-sentry-element="Credenza" data-sentry-component="Credenza" data-sentry-source-file="credenza.tsx">{children}</Credenza>;
};
const CredenzaTrigger = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogTrigger>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaTrigger = isDesktop ? DialogTrigger : DrawerTrigger;
  return <CredenzaTrigger className={className} {...props} data-sentry-element="CredenzaTrigger" data-sentry-component="CredenzaTrigger" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaTrigger>;
};
const CredenzaClose = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogClose>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaClose = isDesktop ? DialogClose : DrawerClose;
  return <CredenzaClose className={className} {...props} data-sentry-element="CredenzaClose" data-sentry-component="CredenzaClose" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaClose>;
};
const CredenzaContent = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogContent>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaContent = isDesktop ? DialogContent : DrawerContent;
  return <CredenzaContent className={className} {...props} data-sentry-element="CredenzaContent" data-sentry-component="CredenzaContent" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaContent>;
};
const CredenzaDescription = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogDescription>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaDescription = isDesktop ? DialogDescription : DrawerDescription;
  return <CredenzaDescription className={className} {...props} data-sentry-element="CredenzaDescription" data-sentry-component="CredenzaDescription" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaDescription>;
};
const CredenzaHeader = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogHeader>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaHeader = isDesktop ? DialogHeader : DrawerHeader;
  return <CredenzaHeader className={className} {...props} data-sentry-element="CredenzaHeader" data-sentry-component="CredenzaHeader" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaHeader>;
};
const CredenzaTitle = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogTitle>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaTitle = isDesktop ? DialogTitle : DrawerTitle;
  return <CredenzaTitle className={className} {...props} data-sentry-element="CredenzaTitle" data-sentry-component="CredenzaTitle" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaTitle>;
};
const CredenzaBody = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('px-4 md:px-0', className)} {...props} data-sentry-component="CredenzaBody" data-sentry-source-file="credenza.tsx">
      {children}
    </div>;
};
const CredenzaFooter = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogFooter>) => {
  const isDesktop = useMediaQuery(desktop);
  const CredenzaFooter = isDesktop ? DialogFooter : DrawerFooter;
  return <CredenzaFooter className={className} {...props} data-sentry-element="CredenzaFooter" data-sentry-component="CredenzaFooter" data-sentry-source-file="credenza.tsx">
      {children}
    </CredenzaFooter>;
};
export { Credenza, CredenzaTrigger, CredenzaClose, CredenzaContent, CredenzaDescription, CredenzaHeader, CredenzaTitle, CredenzaBody, CredenzaFooter };